import React from 'react';
import { CheckStatusButtonProps } from './CheckStatusButton.types';
import { LABELS } from '../../../../constants/LTSConstants';

const CheckStatusButton = (props: CheckStatusButtonProps) => {
  const { isInvalid, onClick } = props;

  return (
    <button
      className={`LTSLanding-CheckStatusButton ${isInvalid ? 'LTSLanding-CheckStatusButton-invalid' : ''}`}
      onClick={onClick}
    >
      {LABELS.CHECK_STATUS}
    </button>
  );
};

export default CheckStatusButton;
